import {
  CreateRecordAuditDefinitionRequestBody,
  UpdateRecordAuditDefinitionRequestBody,
} from '@dms/api/core';

import {RecordAuditDefinitionFormValue} from '../types/RecordAuditDefinitionFormValue';

const toCommonShape = (formData: RecordAuditDefinitionFormValue) => ({
  resourceId: formData.resourceId,
  name: formData.name,
  description: formData.description ?? null,
  category: formData.category ?? null,
  successThreshold: formData.successThreshold,
  sections: formData.sections.map((section) => ({
    id: section.id,
    name: section.name,
  })),
});

export const toCreateRecordAuditDefinitionBody = (
  formData: RecordAuditDefinitionFormValue
): CreateRecordAuditDefinitionRequestBody => ({
  ...toCommonShape(formData),
  tasks: formData.tasks.map((task) => ({
    description: task.description,
    isMandatory: task.isMandatory,
    fileRequired: task.fileRequired,
    weight: task.weight,
    sectionId: task.sectionId,
  })),
});

export const toUpdateRecordAuditDefinitionBody = (
  formData: RecordAuditDefinitionFormValue
): UpdateRecordAuditDefinitionRequestBody => ({
  ...toCommonShape(formData),
  tasks: formData.tasks.map((task) => ({
    id: task.id ?? null,
    description: task.description,
    isMandatory: task.isMandatory,
    fileRequired: task.fileRequired,
    weight: task.weight,
    sectionId: task.sectionId,
  })),
});
